const SELECTORS = {
  root: '[data-google-map]',
  activate: '[data-google-map-activate]',
};

function createIframe({ src, title }) {
  const iframe = document.createElement('iframe');
  iframe.src = src;
  iframe.loading = 'lazy';
  iframe.referrerPolicy = 'no-referrer-when-downgrade';
  iframe.allowFullscreen = true;
  iframe.title = title || 'Google Map';
  return iframe;
}

function activateMap(root) {
  if (!(root instanceof HTMLElement)) return;
  if (root.classList.contains('is-active')) return;
  if (root.querySelector('iframe')) return;

  const src = root.dataset.embedUrl;
  if (!src) return;

  const title = root.dataset.iframeTitle;
  root.appendChild(createIframe({ src, title }));
  root.classList.add('is-active');
}

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const button = target.closest(SELECTORS.activate);
  if (!button) return;

  const root = button.closest(SELECTORS.root);
  if (!root) return;

  event.preventDefault();
  activateMap(root);
});

